<template>
  <populate-form
    v-if="popupAccountFormObj.action==='create'"
    formTitle="建立帳號"
    fkey="ap01"
    ref="AccountPopupForm"
    populateOptionVar="accountFormItemsAdd"
    formDataObjVar="popupAccountFormObj"
    @customValueChanged="formValueChanged"
    :validatePrompt="false"
    :parentVue="this"
  ></populate-form>
  <populate-form
    v-else-if="popupAccountFormObj.action!=='create'"
    formTitle="編輯帳號"
    fkey="ap02"
    ref="AccountPopupForm2"
    populateOptionVar="accountFormItemsUpd"
    formDataObjVar="popupAccountFormObj"
    :validatePrompt="false"
    :parentVue="this"
  ></populate-form>
</template>

<script>

import {
  apiUpdateAccount,
  apiCreateAccount
} from '@/api/Merchant.js'

export default {
  name: 'AccountInfo',
  components: {
    
  },
  props: {
    'cbSave':{
      type:Function,
      default: function () {
        return
      }
    },
    'cbCancel':{
      type:Function,
      default: function () {
        return
      }
    },
    'reloadList':{
      type:Function
    },
    'parentVue': Object,
  },
  data: function () {
    return {
      accountFormItemsAdd:[
        {
          'componentType':'span',
          'akey':'span3',
          'col':2,
          'placeholder':'帳號類型',
          'title':'',
        },
        {
          'componentType':'b-form-select',
          'akey':'role',
          'dataOptions':[{'value':'manager','text':'預約管理者'},{'value':'operator','text':'美容師'}],
          'col':4,
          'placeholder':'',
        },
        {
          'componentType':'span',
          'akey':'span1-0',
          'col':6,
          'placeholder':'',
          'title':'',
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':2,
          'placeholder':'帳號',
          'title':''
        },
        {
          'componentType':'text',
          'akey':'account',
          'col':4,
          'placeholder':'輸入帳號',
          disabled:true
        },
        {
          'componentType':'span',
          'akey':'span1',
          'col':2,
          'placeholder':'姓名',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'account_name',
          'col':4,
          'placeholder':'輸入姓名',
        },
        {
          'componentType':'span',
          'akey':'span4',
          'col':2,
          'placeholder':'密碼',
          'title':'',
        },
        {
          'componentType':'password',
          'akey':'password',
          'col':4,
          'placeholder':'輸入密碼',
        },
        {
          'componentType':'span',
          'akey':'span5',
          'col':2,
          'placeholder':'確認密碼',
          'title':'',
        },
        {
          'componentType':'password',
          'akey':'password2',
          'col':4,
          'placeholder':'再輸入密碼',
        },
        {
          componentType:'btn-group',
          col:11,
          buttons:[
            {
              col:1
            },
            {
              col:4,
              akey:'button_cancel',
              placeholder:'返回',
              execCallback:this.cbCancel
            },
            {
              col:1
            },
            {
              col:4,
              akey:'button_save',
              placeholder:"更新",
              execCallback:this.saveAccount,
              waitClick:true,
            }
          ]
        },
      ],
      accountFormItemsUpd:[
        {
          'componentType':'span',
          'akey':'span1',
          'col':2,
          'placeholder':'姓名',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'account_name',
          'col':4,
          'placeholder':'輸入姓名',
        },
        {
          'componentType':'span',
          'akey':'span1-0',
          'col':6,
          'placeholder':'',
          'title':'',
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':2,
          'placeholder':'帳號',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'account',
          'col':4,
          'placeholder':'輸入帳號',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span3',
          'col':2,
          'placeholder':'帳號類型',
          'title':'',
        },
        {
          'componentType':'b-form-select',
          'akey':'role',
          'dataOptions':[{'value':'admin','text':'店長管理者'},{'value':'manager','text':'預約管理者'},{'value':'operator','text':'美容師'}],
          'col':4,
          'placeholder':'',
          'disabled':true,
        },
        {
          componentType:'btn-group',
          col:11,
          buttons:[
            {
              col:1
            },
            {
              col:4,
              akey:'button_cancel',
              placeholder:'返回',
              execCallback:this.cbCancel
            },
            {
              col:1
            },
            {
              col:4,
              akey:'button_save',
              placeholder:"更新",
              execCallback:this.saveAccount,
              waitClick:true,
            }
          ]
        },
      ],
    }
  },
  methods: {
    formValueChanged(upd) {
      if (upd.key == 'role') {
        // 需要reset account
        if (upd.val=='manager') {
          this.popupAccountFormObj['account'] = this.popupAccountFormObj.base_account+('A'+((this.popupAccountFormObj.manager_last_seq+1)+"").padStart(2,'0'))
        }
        else {
          this.popupAccountFormObj['account'] = this.popupAccountFormObj.base_account+('B'+((this.popupAccountFormObj.operator_last_seq+1)+"").padStart(2,'0'))
        }
      }
    },
    saveAccount (doneCB, evt) {
      let Param = {
        'module':'merchant',
      }
      if (this.popupAccountFormObj['action'] === 'create') {
        if (!this.popupAccountFormObj['account']) {
          this.$refs.AccountPopupForm.triggerAlert('帳號未輸入')
          evt.preventDefault()
          doneCB()
          return
        }
        if (!this.popupAccountFormObj['account_name']) {
          this.$refs.AccountPopupForm.triggerAlert('姓名未輸入')
          evt.preventDefault()
          doneCB()
          return
        }
        if (!this.popupAccountFormObj['password']) {
          this.$refs.AccountPopupForm.triggerAlert('密碼未輸入')
          evt.preventDefault()
          doneCB()
          return
        }
        if (this.popupAccountFormObj['password'] !== this.popupAccountFormObj['password2']) {
          this.$refs.AccountPopupForm.triggerAlert('兩次密碼不同')
          evt.preventDefault()
          doneCB()
          return
        }
        Param.method = 'create_account'
        Param.merchant_store_id = this.popupAccountFormObj['merchant_store_id']
        Param.account = this.popupAccountFormObj['account']
        Param.password = this.popupAccountFormObj['password']
        Param.account_name = this.popupAccountFormObj['account_name']
        Param.account_type = this.popupAccountFormObj['role']
        // Param.account_email = ''
        // Param.account_memo = ''
        // Param.account_self_remark = ''
      }
      else {
        if (!this.popupAccountFormObj['account_name']) {
          this.$refs.AccountPopupForm2.triggerAlert('姓名不可空白')
          evt.preventDefault()
          doneCB()
          return
        }
        Param.method = 'update_account'
        Param.merchant_account_id = this.popupAccountFormObj['merchant_account_id']
        Param.account_name = this.popupAccountFormObj['account_name']
        // Param.account_email = ''
        // Param.account_memo = ''
        // Param.account_self_remark = ''
      }
      let vm = this
      if (Param.method === 'create_account') {
        apiCreateAccount(Param).then(function(resp){
          vm.$bus.fnShowInfo('帳號建立成功')
          vm.reloadList()
          vm.cbCancel()
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
              if (vm.popupAccountFormObj.action === 'create') {
                vm.$refs.AccountPopupForm.triggerAlert(data.msg)
              }
              else {
                vm.$refs.AccountPopupForm2.triggerAlert(data.msg)
              }
              doneCB()
              return
            }
        })
      }
      else {
        apiUpdateAccount(Param).then(function(resp){
          vm.$bus.fnShowInfo('帳號修改成功')
          vm.reloadList()
          vm.cbCancel()
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
              if (vm.popupAccountFormObj.action === 'create') {
                vm.$refs.AccountPopupForm.triggerAlert(data.msg)
              }
              else {
                vm.$refs.AccountPopupForm2.triggerAlert(data.msg)
              }
              doneCB()
              return
            }
        })
      }
      // this.$bus.apiCall(Param, function (data, vm) {
      //   if (data.ok === 0) {
      //       if (vm.popupAccountFormObj.action === 'create') {
      //         vm.$refs.AccountPopupForm.triggerAlert(data.msg)
      //       }
      //       else {
      //         vm.$refs.AccountPopupForm2.triggerAlert(data.msg)
      //       }
      //       doneCB()
      //       return
      //     }
      //     // 成功通知成功後關閉
      //     if (vm.popupAccountFormObj.action === 'create') {
      //       vm.$bus.fnShowInfo('帳號建立成功')
      //     }
      //     else {
      //       vm.$bus.fnShowInfo('帳號修改成功')
      //     }
      //     // 雖然修改可以不用重抓,但要跑迴圈更新列表的data很麻煩,乾脆都reload
      //     vm.reloadList()
      //     vm.cbCancel()
      //     // 如果是create要reload
      // },this)
    }
  },
  computed: {
    parentRef () {
      if (this.parentVue) {
        return this.parentVue
      }
      else {
        // 注意：預設值不對的話(=this)呼叫this.parentRef會因為this.this而循環到自爆
        return this.$parent
      }
    },
    popupAccountFormObj () {
      return this.parentRef['popupAccountFormObj']?this.parentRef['popupAccountFormObj']:{}
    }
  },
  created() {
    
  },
  mounted() {
    
  },
  watch: {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
